// extracted by mini-css-extract-plugin
export default {"Logo":"Main_Logo__SdfAw","Main":"Main_Main__sluFA"};